import { List as ImmutableList, Record } from 'immutable';
import { handleActions } from 'redux-actions';

import { getLogger } from '../../utils/core';
import { coreActions } from '../core-actions';

import * as undoActions from './undoActions';

const log = getLogger('data/undo/undoReducer.js');
export const UNDO_REDUCER_KEY = 'undoStore';

export const mkUndoStore = Record({
  undoStack: ImmutableList(),
});

const maxUndoStackSize = 1;

export const reducer = handleActions(
  {
    [coreActions.sanitize]: (state) => state.delete('undoStack'),

    [undoActions.addUndo]: (state, { payload: undo }) => {
      log.log('addUndoAction...');
      return state.merge({
        undoStack: state.undoStack.takeLast(maxUndoStackSize - 1).push(undo),
      });
    },

    [undoActions.undo]: (state, { payload: undoToDispatch, asyncDispatch }) => {
      log.log('dispatchPostponedActions...');
      undoToDispatch.actions.forEach((action) => asyncDispatch(action));
      return state.merge({
        undoStack: state.undoStack.filterNot((undo) => undo === undoToDispatch),
      });
    },

    [undoActions.deleteUndo]: (state, { payload: undoToDismiss }) => {
      log.log('deleteUndoAction...');
      return state.merge({
        undoStack: state.undoStack.filterNot((undo) => undo === undoToDismiss),
      });
    },

    [undoActions.clearUndoStack]: (state) => {
      log.log('deleteUndoAction...');
      return state.merge({
        undoStack: ImmutableList(),
      });
    },
  },
  mkUndoStore(),
);

export default reducer;
